import React from 'react';
import IntegrationsConfigSection from '../../../sections/AdminDashboard/Settings/IntegrationsConfig';

const IntegrationsConfig = () => {
  return <IntegrationsConfigSection />;
};

export default IntegrationsConfig;

